import { Loading } from "@app/components";
import {
  useAnalysisTypes,
  useIsotopos,
  useIsotoposInstalacion,
  useUser,
} from "@services/servicesGenericsTables";
import { useBackgroundCodes } from "@services/servicesGenericsTables/useBackgroundCodes";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

export default function LayoutEditFondo() {
  const [loading, setLoading] = useState<boolean>(true);

  const { fetchAll: fetchAllUser } = useUser();
  const { fetchAll: fetchAllIsotoposIntalation } = useIsotoposInstalacion();
  const { fetchAll: fetchAllIsotopos } = useIsotopos();
  const { fetchAll: fetchAllAnalysis } = useAnalysisTypes();
  const { fetchAll: fetchAllCodes } = useBackgroundCodes();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          fetchAllUser(),
          fetchAllIsotopos(),
          fetchAllIsotoposIntalation(),
          fetchAllAnalysis(),
          fetchAllCodes(),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return loading ? <Loading /> : <Outlet />;
}
